document.addEventListener("DOMContentLoaded", function () {
    function getTimeUntilMidnight() {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0); // Sets to 12:00 AM (next day)
        return midnight - now;
    }

    function startCountdown() {
        const countdownTime = getTimeUntilMidnight();
        
        function updateCountdown() {
            const timeLeft = getTimeUntilMidnight();
            
            const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
            const seconds = Math.floor((timeLeft / 1000) % 60);

            document.getElementById("hours").textContent = String(hours).padStart(2, '0');
            document.getElementById("minutes").textContent = String(minutes).padStart(2, '0');
            document.getElementById("seconds").textContent = String(seconds).padStart(2, '0');

            if (timeLeft <= 0) {
                clearInterval(interval);
                startCountdown(); // Restart countdown for the next day
            }
        }

        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);
    }

    startCountdown();
});
